import { ChevronsUpDown } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useUserMenuData, UserMenuItems } from "./UserMenu";

/**
 * Profile menu for the sidebar rail — used on tablet, where the page owns the
 * top bar and the TopBar profile menu isn't shown. Collapses to just the avatar
 * via SidebarMenuButton's icon sizing. On desktop the profile stays in the TopBar.
 */
export function SidebarUserMenu() {
  const { displayName, displayEmail, initials } = useUserMenuData();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              tooltip={displayName}
              className="text-sidebar-muted hover:bg-sidebar-hover hover:text-sidebar-accent-foreground data-[state=open]:bg-sidebar-hover data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="size-8 shrink-0 rounded-md border border-sidebar-border">
                <AvatarFallback className="rounded-md bg-sidebar-hover text-xs text-sidebar-foreground">
                  {initials}
                </AvatarFallback>
              </Avatar>
              <div className="flex min-w-0 flex-col text-left leading-tight group-data-[collapsible=icon]:hidden">
                <span className="truncate text-sm font-medium text-sidebar-foreground">
                  {displayName}
                </span>
                {displayEmail && (
                  <span className="truncate text-[11px] text-sidebar-muted">
                    {displayEmail}
                  </span>
                )}
              </div>
              <ChevronsUpDown className="ml-auto size-4 shrink-0 group-data-[collapsible=icon]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <UserMenuItems side="right" align="end" />
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
